
<template>
  <v-scale-transition>
    <panel
      :title="title"
      :breadcrumbs="breadcrumbs"
    >
      <v-toolbar
        card
        extended
      >
        <v-container fluid>
          <v-layout row>
            <v-flex xs3>
              <v-select
                v-model="filter"
                :items="filters"
                item-text="text"
                item-value="value"
                label="Filter by"
              />
            </v-flex>
            <v-flex xs3>
              <v-text-field
                v-if="filter !== null"
                v-model="search"
                label="Enter search string"
                clearable
              />
            </v-flex>
            <v-card-actions>
              <v-spacer />
              <v-btn
                v-if="filter !== null"
                color="primary"
                dark
                class="mb-2"
                @click="refreshList()"
              >
                Search
              </v-btn>
            </v-card-actions>
            <v-flex xs1>
              <v-spacer />
              <v-checkbox
                v-model="xox"
                label="XOX"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-toolbar>
      <v-card>
        <v-card-text>
          <v-data-table
            :headers="headers"
            :loading="loading"
            :items="items"
            :pagination.sync="pagination"
            :total-items="totalItems"
            :rows-per-page-items="[10, 25, 50, 100]"
            :expand="true"
            class="px-1 pb-1"
          >
            <template #items="props">
              <tr @click="props.expanded = !props.expanded">
                <td
                  v-if="props.item.tarikh"
                  class="text-xs-left"
                >
                  {{ props.item.tarikh }}
                </td>
                <td
                  v-else
                  class="text-xs-left"
                >
                  -
                </td>
                <td
                  v-if="props.item.dealerId"
                  class="text-xs-center"
                >
                  {{ props.item.dealerId }}
                </td>
                <td
                  v-else
                  class="text-xs-center"
                >
                  -
                </td>
                <td
                  v-if="props.item.nohp"
                  class="text-xs-center"
                >
                  {{ props.item.nohp }}
                </td>
                <td
                  v-else
                  class="text-xs-center"
                >
                  -
                </td>
                <td
                  v-if="props.item.amaun"
                  class="text-xs-right"
                >
                  {{ props.item.amaun }}
                </td>
                <td
                  v-else
                  class="text-xs-right"
                >
                  -
                </td>
              </tr>
            </template>
            <template slot="no-data">
              <v-alert
                :value="true"
                :type="error ? 'error' : 'info'"
              >
                {{ noDataText }}
              </v-alert>
            </template>
            <template #footer>
              <tr>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td
                  class="text-xs-right"
                >
                  Total:
                </td>
                <td class="text-xs-right">
                  RM {{ totalTopup }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </panel>
  </v-scale-transition>
</template>

<script>
import { createGetParams } from '@/rest'
import security from '@/security'
// import Jimp from 'jimp'

const pageTitle = 'Topup History'

export default {
  components: {
    Panel: () => import(/* webpackChunkName: "panel" */ '@/components/Panel'),
  },
  data () {
    return {
      breadcrumbs: [
        {
          text: 'DMT Kits', disabled: false, to: '/support/dmt_kits',
        },
        {
          text: pageTitle, disabled: true,
        },
      ],
      activeItem: null,
      alert: false,
      alertType: null,
      alertMessage: null,
      xox: null,
      error: null,
      filter: null,
      filters: [
        {
          text: 'Msisdn',
          value: 'nohp',
        },
        {
          text: 'DREG',
          value: 'dealerId',
        },
      ],
      headers: [
        {
          text: 'Date',
          align: 'left',
          sortable: true,
          value: 'tarikh',
        },
        {
          text: 'Topup by',
          align: 'center',
          sortable: true,
          value: 'dealerId',
        },
        {
          text: 'Subscriber',
          align: 'center',
          sortable: true,
          value: 'nohp',
        },
        {
          text: 'Topup (RM)',
          align: 'right',
          sortable: false,
          value: 'amaun',
        },
      ],
      items: [],
      totalTopup: '0.00',
      onex: true,
      loading: false,
      pagination: {},
      snackbar: false,
      snackbarMessage: null,
      search: null,
      searchId: null,
      source: null,
      title: pageTitle,
      totalItems: 0,
    }
  },
  computed: {
    noDataText: function () {
      return this.error ? this.error : "There's nothing to display."
    },
  },
  watch: {
    xox: function (val) {
      this.onex = !val
    },
    filter: function () {
      (this.search) && this.resetList()
    },
    pagination: {
      handler () {
        this.refreshList()
      },
      deep: true,
    },
  },
  mounted: function () {
    this.xox = security.me.claimer() === 'xox'
  },
  methods: {
    async getUserList () {
      const filters = this.getFilters()
      if (!filters) return { items: [], totalItems: 0 }
      this.loading = true
      const { page, rowsPerPage } = this.pagination
      const parameters = {
        page,
        rowsPerPage,
      }
      Object.assign(parameters, filters)

      const apiParameters = createGetParams(parameters)
      try {
        this.source = this.$rest.CancelToken.source()
        Object.assign(apiParameters, { cancelToken: this.source.token })
        const response = await this.$rest.get('getTopupHistory.php', apiParameters)
        this.error = null
        this.loading = false
        this.totalTopup = response.data.totalTopup
        return response.data
      } catch (error) {
        if (!this.$rest.isCancel(error)) {
          this.error = error.message
        }
        return { items: [], totalItems: 0 }
      }
    },
    getFilters () {
      const filterBy = {}

      if (this.filter === 'nohp' && this.search) {
        Object.assign(filterBy, { nohp: this.search })
      }

      if (this.filter === 'dealerId' && this.search) {
        Object.assign(filterBy, { dealerId: this.search })
      }

      Object.assign(filterBy, { onex: this.onex })

      return this.filter && (this.search) ? filterBy : null
    },
    cancelRequest: function () {
      if (this.source) {
        this.source.cancel('Forced cancellation.')
        this.source = null
      }
    },
    refreshList () {
      this.getUserList().then(data => {
        this.items = data.items
        this.totalItems = data.totalItems
      })
    },
    resetList () {
      this.items = []
      this.totalItems = 0
    },
    showError (message) {
      this.alertType = 'error'
      this.alertMessage = message
      this.alert = true
    },
  },
}
</script>
